import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  ScreenDisplayHeaderActions,
  TabButtonFlatButton,
  TextInputField,
} from "../../../common-components";
import { TaskHeader, TaskItem, ManageTaskPopUp } from "./components";
import SearchBar from "../../../common-components/search-bar/SearchBar";

const TasksDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
}) => {
  const [open, setOpen] = useState(false);
  const [allTaskArray, setAllTaskArray] = useState([]);
  const [openTaskArray, setOpenTaskArray] = useState([]);
  const [completedTaskArray, setCompletedTaskArray] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [tableDisplay, setTableDisplay] = useState("all");
  const [selectedTask, setSelectedTask] = useState(null);
  const [activeView, setActiveView] = useState("search");
  const [originalDataArray, setOriginalDataArray] = useState(null); //retain original data for clearing search

  const getTaskArrays = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/task/getAllTaskData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();
      console.log(responseData);
      if (responseData.success) {
        setAllTaskArray(responseData.taskData);
        setOriginalDataArray(responseData.taskData);
        let openTA = [];
        let completedTA = [];
        responseData.taskData.forEach((task) => {
          if (
            task.taskStatus === "Requested" ||
            task.taskStatus === "In-progress" ||
            task.taskStatus === "Accepted" ||
            task.taskStatus === "Pending"
          ) {
            openTA.push(task);
          }

          if (task.taskStatus === "Completed") completedTA.push(task);
        });

        setOpenTaskArray(openTA);
        setCompletedTaskArray(completedTA);

        setLoading(false);
      } else {
        setPopUpTitle("FAILURE");
        setToastPop(true);
        setMessage(responseData.message);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setPopUpTitle("FAILURE");
      setToastPop(true);
      setMessage(
        "No network try again after connecting, if this persist please contact support"
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    setOpen(true);
  }, []);
  useEffect(() => {
    getTaskArrays();
  }, [refresh]);
  useEffect(() => {
    getTaskArrays();
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
      }}
    >
      <div
        style={{
          display: "flex",
          height: 40,
          backgroundColor: colors.greenDark,
          top: -40,
          position: "absolute",
        }}
      >
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"ALL TASKS"}
            backgroundColor={
              tableDisplay === "all" ? colors.secondaryGrey : colors.greenLight
            }
            textColor={tableDisplay === "all" ? colors.greenDark : colors.white}
            onClick={() => setTableDisplay("all")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"OPEN TASKS"}
            backgroundColor={
              tableDisplay === "open" ? colors.secondaryGrey : colors.greenLight
            }
            textColor={
              tableDisplay === "open" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("open")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"COMPLETED TASKS"}
            backgroundColor={
              tableDisplay === "completed"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "completed" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("completed")}
          />
        </div>
      </div>

      <div
        style={{
          height: 55,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
          TASKS
        </div>
        <div style={{ flex: 0.5 }}></div>
        <SearchBar
          originalSearchArray={originalDataArray}
          arrayToSearchInput={allTaskArray}
          setResultsArray={setAllTaskArray}
        />
        <div style={{ flex: 0.5 }}></div>
      </div>
      <TaskHeader />
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          overflow: "scroll",
          justifyContent: "flex-start",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {selectedTask
          ? null
          : allTaskArray && tableDisplay === "all"
          ? allTaskArray.map((task, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <TaskItem
                    onViewClick={() => setSelectedTask(task)}
                    task={task}
                  />
                </div>
              );
            })
          : null}
        {selectedTask
          ? null
          : openTaskArray && tableDisplay === "open"
          ? openTaskArray.map((task, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <TaskItem
                    onViewClick={() => setSelectedTask(task)}
                    task={task}
                  />
                </div>
              );
            })
          : null}
        {selectedTask
          ? null
          : completedTaskArray && tableDisplay === "completed"
          ? completedTaskArray.map((task, index) => {
              return (
                <div key={index} style={{ width: "100%" }}>
                  <TaskItem
                    onViewClick={() => setSelectedTask(task)}
                    task={task}
                    setSelectedTask={setSelectedTask}
                  />
                </div>
              );
            })
          : null}
      </div>
      {selectedTask ? (
        <ManageTaskPopUp
          activeView={activeView}
          setActiveView={setActiveView}
          loading={loading}
          setLoading={setLoading}
          auth={auth}
          setRefresh={setRefresh}
          refresh={refresh}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setMessage={setMessage}
          setSelectedTask={setSelectedTask}
          selectedTask={selectedTask}
        />
      ) : null}
    </div>
  );
};

export default TasksDisplay;
